<div class="grid tk-grid-rows place-items-center h-screen tk-bg-gray-1 tk-i-background">

  <div [formGroup]="form" class="mx-auto flex-1 flex-col place-items-center w-80">

    <div class="mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
    </div>

    <div class="text-lg font-semibold text-center mb-3">{{'select-database.select-client-database' | translate}}</div>

<!--    <div class="text-lg font-semibold text-center mb-10">Masz {{timeLeftToChooseDatabase}} sekund na wybór bazy.</div>-->

    <mat-form-field class="w-full mb-10" hideRequiredMarker>
      <mat-label>{{'select-database.select-client-database' | translate}}</mat-label>
      <input type="text" matInput formControlName="database" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <cdk-virtual-scroll-viewport [style]="{height: height}" itemSize="50" minBufferPx="200" maxBufferPx="300">
          <mat-option *cdkVirtualFor="let option of filtered | async" [value]="option" class="tk-height-50">
            {{option}}
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </mat-autocomplete>
      <mat-error id="database-error-required" *ngIf="databaseCtrl.hasError('required')">
        {{'errors.field-is-required' | translate}}
      </mat-error>
    </mat-form-field>

    <app-button [isLoading]="isLoading" [isFullWidth]="true" [isActive]="!form.pristine"
                innerTextClasses="my-1.5" spinnerClasses="my-3" label="{{'labels.continue' | translate | titlecase}}"
                (click)="onContinue()"></app-button>
  </div>

  <am-login-footer class="mb-8 w-full"></am-login-footer>

</div>
